import React from 'react';

import { ArrowLeft } from '@crehana/icons/outline';

import { useTranslation } from '@crehana/i18n';

import Loadable from 'Jsx/Shared/Loadable';

import PaymentMethodsSection from 'Jsx/CheckoutV4/components/PaymentMethodsSection/PaymentMethodsSection';
import PersuasionNotification from 'Jsx/CheckoutV4/components/PersuasionNotification';
import { useCheckoutContext } from 'Jsx/CheckoutV4/Context';

import { PageProps } from '..';

import TotalToPayA from './components/PurchaseDetail/TotalToPayA';
import Header from './components/Header';

const CheckoutDesktop: React.FC<PageProps> = ({
  setSelectedQuotaNumber,
  selectedQuotaNumber,
  displayTimer,
  quotas,
  selectedQuota,
  isCallCenter,
}) => {
  const { t } = useTranslation();
  const {
    isGuestCheckout,
    checkoutProductDetail,
    paymentMethods,
    checkoutProductsList,
    productData,
    countryPrefix,
    handleApplyCoupon,
    handleRemoveCoupon,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    isQuickEnrollEnabled,
    paymentFormValues,
    guestEmail,
    showPaymenButtonRight,
  } = useCheckoutContext();
  const { isCouponEnabled, showContactNumber, callCenter, pageCoupon } =
    productData;

  if (!checkoutProductDetail) return <div />;

  const showCampaignInfo =
    !isCallCenter && checkoutProductDetail?.type !== 'degree';

  return (
    <div className="h-screen overflow-x-hidden bg-gray-lighter">
      <Header
        itemType={productData.itemType}
        displayTimer={!showCampaignInfo ? displayTimer : undefined}
        isValidDuringCall={callCenter?.isValidDuringCall}
      />
      <div
        className="flex items-start justify-between pt-24 pb-48 mx-auto px-48 lg:px-0"
        style={{ maxWidth: 1152 }}
      >
        <div className="min-h-screen w-full mr-64" style={{ maxWidth: 630 }}>
          <PersuasionNotification imageClassName="max-w-40" className="mb-40" />
          {selectedPaymentMethod && (
            <button
              className="font-button text-primary-main flex items-center mb-24"
              type="button"
              onClick={() => setSelectedPaymentMethod(undefined)}
            >
              <ArrowLeft
                size={24}
                ignoreColor
                className="fill-current text-primary-main"
              />{' '}
              <span className="ml-8">{t('GO_BACK_2')}</span>
            </button>
          )}

          <PaymentMethodsSection
            paymentMethods={paymentMethods}
            isMarketProduct={checkoutProductDetail.type === 'product'}
            isQuickEnrollEnabled={isQuickEnrollEnabled}
            isGuestCheckout={isGuestCheckout}
            symbol={checkoutProductDetail.codeSymbol}
            quotas={quotas}
            selectedQuotaNumber={selectedQuotaNumber}
            setSelectedQuotaNumber={setSelectedQuotaNumber}
            isDesktop
          />
          {!selectedPaymentMethod && (
            <TotalToPayA
              codeSymbol={checkoutProductDetail.codeSymbol}
              price={
                selectedQuota?.newTotalLocal || checkoutProductDetail.price
              }
              realPrice={checkoutProductDetail.realPrice}
              className="mt-40"
            />
          )}
        </div>
        <Loadable
          module={() =>
            import(
              /* webpackChunkName: "right-user-interface-desktop" */ './components/PurchaseDetail'
            )
          }
          checkoutProductsList={checkoutProductsList}
          checkoutProductDetail={checkoutProductDetail}
          handleApplyCoupon={handleApplyCoupon}
          handleRemoveCoupon={handleRemoveCoupon}
          callCenter={callCenter}
          isCouponEnabled={isCouponEnabled}
          countryPrefix={countryPrefix}
          showContactNumber={showContactNumber}
          selectedQuota={selectedQuota}
          selectedPaymentMethod={selectedPaymentMethod}
          paymentFormValues={paymentFormValues}
          guestEmail={guestEmail}
          isGuestCheckout={isGuestCheckout}
          canApplyCouponOnfirstRender={pageCoupon?.isValid}
          showPaymenButtonRight={showPaymenButtonRight}
        />
      </div>
    </div>
  );
};

export default CheckoutDesktop;
